
import React, { useEffect, useState } from 'react';
import useAxios from "../../hooks/useAxios";
import Loading from '../../components/Loading';
const FiredUpToVoteSignup = ({
  formData,
  handleChange,
  handleSubmitNameStep,
  isWaiting
}) => {
  const { post } = useAxios();
  const [isMobile, setIsMobile] = useState(false);
  const [isSubmitDisable, setISubmitDisable] = useState(false);
  const [schoolOptions,setSchoolOptionsArray] = useState([]);
  const checkFormValidity = () => {
    const { firstName, middleName, lastName, isPrecintChair, precinctNumber } = formData;
    const isValid = firstName && lastName && middleName && (isPrecintChair === 'No' || (isPrecintChair === 'Yes' && precinctNumber));
    setISubmitDisable(!isValid);
  };

  useEffect(() => {
    checkFormValidity();
  }, [formData]); 
  
  // Check for mobile view on mount and window resize
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1023);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    setSchoolOptions();
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);


  const setSchoolOptions = async () => {
    await post(
      process.env.REACT_APP_ADMIN_API_URL,
      {
        purpose: 'get_school_district'
      },
      (response) => {
        console.log(response.data.data);
        setSchoolOptionsArray(response.data.data);
      },
      {},
      {},
      false
    );
  }

  const handleSubmit = () => {
    handleSubmitNameStep();
  }

  return (
    <div className="w-full px-20px max-w-[1336px] font-fira xl:mt-[232px] lg:mt-[190px] mt-[140px] mx-auto lg-xl:mb-20 lg:mb-15 mb-10">
      <div className={`flex overflow-hidden ${isMobile ? 'flex-col-reverse' : ''}`}>
        {/* Left Side - Benefits Section */}
        <div className={`${isMobile ? 'w-full rounded-b-[16px]' : 'max-w-[671px] w-full rounded-tl-[16px] rounded-bl-[16px]'} p-[20px] lg:p-[40px] text-white`} style={{ backgroundColor: '#00066A' }}>
          <h2 className="font-bold lg-xl:text-[50px] lg-xl:leading-[65px] lg:text-[40px] lg:leading-[55px] sm:text-[32px] sm:leading-[45px] text-[28px] leading-[40px] tracking-normal uppercase font-fira mb-20px">
            WHY JOIN <span className='text-customRed'>FIRED UP TO VOTE!</span>
          </h2>
          <ul className="space-y-4">
            {[
              'Increase Voter Turnout',
              'Statistically Proven Results',
              'Free Software Tool',
              'Easy to Use',
              'Convenient / Use Tool From Anywhere',
              'Strengthen Civic Engagement'
            ].map((benefit, index) => (
              <li key={index} className="flex items-center">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none" className="lg-xl:w-[25px] lg-xl:h-[25px] w-[20px] h-[20px]">
                    <path d="M25 13C25 19.9052 19.3548 25.5 12.5 25.5C5.59476 25.5 0 19.9052 0 13C0 6.14516 5.59476 0.5 12.5 0.5C19.3548 0.5 25 6.14516 25 13ZM11.0383 19.6532L20.3125 10.379C20.6149 10.0766 20.6149 9.52218 20.3125 9.21976L19.1532 8.11089C18.8508 7.75806 18.3468 7.75806 18.0444 8.11089L10.4839 15.6714L6.90524 12.1431C6.60282 11.7903 6.09879 11.7903 5.79637 12.1431L4.6371 13.252C4.33468 13.5544 4.33468 14.1089 4.6371 14.4113L9.87903 19.6532C10.1815 19.9556 10.7359 19.9556 11.0383 19.6532Z" fill="#D30039"></path>
                  </svg>
                </span>
                <span className="xs:ml-[15px] ml-[10px] xl:text-22px xl:leading-[35.2px] text-[20px] leading-[28px] font-fira font-medium">{benefit}</span>
              </li>
            ))}
          </ul>

          <div className="bg-white w-[243px] h-[140px] mt-[30px] mx-auto flex items-center justify-center mb-[30px] rounded-[10px]">
            <img src="../../hero-img_sm.png" alt="hero" className="object-contain p-3" />
          </div>
        </div>
        
        {/* Right Side - Form Section */}
        <div className={`${isMobile ? 'w-full rounded-t-[16px]' : 'max-w-[625px] w-full rounded-tr-[16px] rounded-br-[16px]'} border border-[#CCCCCC] p-[20px] lg:p-[40px] relative`}>
          <h2 className="font-bold lg-xl:text-[50px] lg-xl:leading-[65px] lg:text-[40px] lg:leading-[55px] sm:text-[32px] sm:leading-[45px] text-[28px] leading-[40px] text-lightBlack tracking-normal uppercase font-fira">ACCOUNT SETUP</h2>
          <div className="mb-20px mt-[10px] xl:text-22px xl:leading-[28.6px] text-[20px] leading-normal font-fira font-normal text-lightBlack">Please enter your full legal name in the box below.</div>
          
          <div className="">
            <div className='lg:mb-[20px] mb-[15px]'>
              <label className="xl:text-[20px] font-medium xl:leading-[26px] text-[18px] leading-[22px] tracking-normal font-fira mb-[10px] block">
                First Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="firstName"
                placeholder="Enter First Name"
                className="w-full px-[10px] py-[4px] xs:px-[10px] xs:py-[7px] md:px-[20px] md:py-[10px] border border-[#DDDDDD] rounded-[8px] focus-visible:outline-cherry text-xl placeholder-black placeholder:text-lg lg-xl:placeholder:text-xl capitalize"
                value={formData.firstName}
                onChange={handleChange}
                required
                style={{ placeholderColor: 'red' }} // Changed this line to change the color of the placeholder text
              />
            </div>
            <div className='xs:flex xs:gap-[20px] xs:items-center lg:mb-[20px] mb-[15px]'>
              <div className='w-full xs:mb-0 mb-[15px]'>
                <label className="xl:text-[20px] font-medium xl:leading-[26px] text-[18px] leading-[22px] tracking-normal font-fira mb-[10px] block">
                  Middle Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="middleName"
                  placeholder="Enter Middle Name"
                  className="w-full px-[10px] py-[4px] xs:px-[10px] xs:py-[7px] md:px-[20px] md:py-[10px] border border-[#DDDDDD] rounded-[8px] focus-visible:outline-cherry text-xl placeholder-black placeholder:text-lg lg-xl:placeholder:text-xl capitalize"
                  value={formData.middleName}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className='w-full'>
                <label className="xl:text-[20px] font-medium xl:leading-[26px] text-[18px] leading-[22px] tracking-normal font-fira mb-[10px] block">
                  Last Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="lastName"
                  placeholder="Enter Last Name"
                  className="w-full px-[10px] py-[4px] xs:px-[10px] xs:py-[7px] md:px-[20px] md:py-[10px] border border-[#DDDDDD] rounded-[8px] focus-visible:outline-cherry text-xl placeholder-black placeholder:text-lg lg-xl:placeholder:text-xl capitalize"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            
            <div className='lg:mb-[20px] mb-[15px]'>
              <label className="xl:text-[20px] font-medium xl:leading-[26px] text-[18px] leading-[22px] tracking-normal font-fira mb-[10px] block">
                Are you Precinct Chair?
              </label>
              <div className="flex items-center space-x-4">
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="isPrecintChair"
                    className="peer hidden"
                    value="Yes"
                    checked={formData.isPrecintChair === 'Yes'}
                    onChange={handleChange}
                  />
                  <div className="w-5 h-5 border-2 border-black-600 rounded-full flex items-center justify-center peer-checked:bg-white peer-checked:border-black">
                    <div className={`w-3 h-3 ${formData.isPrecintChair === 'Yes' ? 'bg-black' : ''} rounded-full`}></div>
                  </div>
                  <span className="text-black xl:text-[20px] font-normal xl:leading-[26px] text-[18px] leading-[22px] tracking-normal font-fira">Yes</span>
                </label>
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="isPrecintChair"
                    value="No"
                    checked={formData.isPrecintChair === 'No'}
                    onChange={handleChange}
                    className="peer hidden"
                  />
                  <div className="w-5 h-5 border-2 border-black-600 rounded-full flex items-center justify-center peer-checked:bg-white peer-checked:border-black">
                    <div className={`w-3 h-3  ${formData.isPrecintChair === 'No' ? 'bg-black' : ''} rounded-full`}></div>
                  </div>
                  <span className="text-black xl:text-[20px] font-normal xl:leading-[26px] text-[18px] leading-[22px] tracking-normal font-fira">No</span>
                </label>
              </div>
            </div>

            {formData.isPrecintChair === 'Yes' && <div className='lg:mb-[20px] mb-[15px]'>
              <label className="xl:text-[20px] font-medium xl:leading-[26px] text-[18px] leading-[22px] tracking-normal font-fira mb-[10px] block">
                What is your Precinct Number? <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="precinctNumber"
                placeholder="Enter Precinct Number"
                className="w-full px-[10px] py-[4px] xs:px-[10px] xs:py-[7px] md:px-[20px] md:py-[10px] border border-[#DDDDDD] rounded-[8px] focus-visible:outline-cherry text-xl placeholder-black placeholder:text-lg lg-xl:placeholder:text-xl"
                value={formData.precinctNumber}
                onChange={(e) => {
                  const value = e.target.value;
              
                  // Allow clearing input
                  if (value === "") {
                    handleChange(e);
                    return;
                  }
              
                  // Ensure value is a number and within range
                  const numberValue = Number(value);
                  if (/^\d+$/.test(value) && numberValue >= 1 && numberValue <= 1152) {
                    handleChange(e);
                  }
                }}
                required
              />
            </div>}
            
            <div className='hidden lg:mb-[20px] mb-[15px]' >
              <label className="xl:text-[20px] font-medium xl:leading-[26px] text-[18px] leading-[22px] tracking-normal font-fira mb-[10px] block">
                Select School District
              </label>
              <div className='relative'>
                <div className="absolute inset-y-0 right-4 flex items-center pl-3 pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <select
                  name="schoolDistrict"
                  className="appearance-none  w-full px-[10px] py-[4px] xs:px-[11px] xs:py-[7px] md:px-[20px] md:py-[11px] border border-[#DDDDDD] rounded-[8px] focus-visible:outline-cherry text-xl placeholder-black placeholder:text-lg lg-xl:placeholder:text-xl"
                  value={formData.schoolDistrict}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  {schoolOptions.map((option) => (
                    <option key={option.id} value={option.id}>{option.school_district_name}</option>
                  ))}
                </select>
              </div>
            </div>
            
            <button
              type="submit"
              disabled={isSubmitDisable || isWaiting}
              className={`uppercase xl:text-22px lg:mx-0 mx-auto xl:leading-[23.4px] text-18px leading-[23px] text-white font-fira font-normal  flex items-center xl:py-[14.3px] xl:px-[30px] py-2 px-3 ${
                (isSubmitDisable) ? 'bg-gray-400 cursor-not-allowed' : 'hover:bg-darkRed bg-customRed cursor-pointer'
              }`}
              onClick={handleSubmit}
            >
                {isWaiting ? <Loading size={26} invert /> :
                <>
                  <span className="">SUBMIT</span>
                  <img className="w-[8px] h-[14px] ml-[20px]" src={"/arrow_forward.svg"} alt="arrow_forward" />
                </>
              }
            </button>

            <div className='mt-3'>
              <p className='font-semiBold font-fira font-normal xl:text-22px text-[20px]'>If you are not registered to vote in Harris County, please contact <span className='text-cherry'>support@fireduptovote.com</span> and we will be in touch shortly</p>
            </div>
          </div>
          
          {/* {! isMobile  && (
            <div className="absolute bottom-0 right-0">
              <img src="/AccountSetupLogo.png" alt="Account Setup Logo" className="xl:max-w-full max-w-[70%]" />
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default FiredUpToVoteSignup;
